<template>
  <div :id="modalName" class="modal-contents">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container relative">
            <span @click="$emit('close')" class="absolute right-0 top-0 mt-2">
              <Zondicon
                class="nav-icon w-4 cursor-pointer fill-current"
                icon="Close"
              />
            </span>
            <div class="modal-body">
              <slot name="body">
                default body
              </slot>
            </div>

            <div class="modal-footer">
              <span @click="$emit('close')" class="hidden modal-default-button">
                OK
              </span>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["content", "modalName"],
  data() {
    return {
      show: false
    };
  },
  mounted() {
    let modalContainer = document.getElementById(this.modalName);

    modalContainer.addEventListener("click", function(e) {
      e.stopPropagation(); // this will stop propagation of this event to upper level
    });

    let that = this;
    document.body.addEventListener("click", function(e) {
      that.$emit("close");
    });
  }
};
</script>

<style lang="scss">
.modal-contents {
  display: inline-block;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  pointer-events: initial;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-button {
  top: -7px;
  position: relative;
  padding: 0px 10px;
  right: 7px;
  font-weight: bold;
}

.modal-button:hover {
  cursor: pointer;
}

/*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
